import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Account, OrgProgram, Organization, OrganizationData, Payer } from '@core/models';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable()
export class OrganizationsService {

  basePath: string;

  constructor(private readonly configService: ConfigService, private readonly httpClient: HttpClient) {
    this.basePath = `${this.configService.appConfig.api.uoUrl}/org`;
  }
  getOrganizations(): Observable<Organization[]> {
    return this.httpClient.get<Organization[]>(`${this.basePath}/list`);
  }

  createOrEdit(organizationData: OrganizationData): Observable<Organization> {

    const formData = new FormData();
    formData.append('orgName', organizationData.orgName);
    formData.append('contactName', organizationData.contactName);
    formData.append('parentCompany', organizationData.parentCompany);

    if (organizationData.file !== null) {
      formData.append('file', organizationData.file);
    }

    if (organizationData.orderAccountFile != null) {
      formData.append('orderAccountFile', organizationData.orderAccountFile);
    }

    if (organizationData.programFile != null) {
      formData.append('programFile', organizationData.programFile)
    }

    if (organizationData.restrictedAnalytes != null) {
      formData.append('restrictedAnalytes', JSON.stringify(organizationData.restrictedAnalytes));
    }

    if (organizationData.orgId) {
      formData.append('orgId', organizationData.orgId.toString());
    }

    if (organizationData.orgId) {
      return this.httpClient.put<Organization>(`${this.basePath}/edit`, formData);
    } else {
      return this.httpClient.post<Organization>(`${this.basePath}/create`, formData);
    }
  }

  delete(orgId: number): Observable<boolean> {
    return this.httpClient.delete<boolean>(`${this.basePath}/delete/${orgId}`);
  }

  getPrograms(orgId: number): Observable<OrgProgram[]> {
    return this.httpClient.get<OrgProgram[]>(`${this.basePath}/programs/${orgId}`);
  }

  deletePrograms(orgId: number): Observable<boolean> {
    return this.httpClient.delete<boolean>(`${this.basePath}/programs/${orgId}`);
  }

  getPayerAccounts(): Observable<Payer[]> {
    return this.httpClient.get<Payer[]>(`${this.basePath}/payerAccounts`);
  }

  getOrderAccounts(): Observable<Account[]> {
    return this.httpClient.get<Account[]>(`${this.basePath}/orderingAccounts`);
  }

  getOrgAccounts(orgId: number): Observable<Account[]> {
    return this.httpClient.get<Account[]>(`${this.basePath}/getOrgAccounts/${orgId}`);
  }

  getOrgOrderAccounts(orgId: number): Observable<Account[]> {
    return this.httpClient.get<Account[]>(`${this.basePath}/getOrgOrderAccounts/${orgId}`);
  }
}
